export default (el, speed = 2) => {
  const winHeight = window.innerHeight
  document.addEventListener('scroll', _e => {
    const lastScroll = window.scrollY
    if (lastScroll < winHeight) {
      el.style.transform = 'translate3d(0,' + lastScroll / speed + 'px,0)'
    }
  })
}
